import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const updatePurchaseOrder = async (id, payload) => {
  try {
    const response = await apiClient.put(
      `/adminInvoiceManagement/purchaseOrderManagement/${id}`,
      payload
    );

    if (response.status === 200 || response.status === 201) {
      // Handle the response structure: { success, message, data }
      return {
        success: true,
        data: response.data?.data || response.data?.response || response.data,
        message: response.data?.message || 'PO record updated successfully',
      };
    } else {
      const errorMessage = response.data?.error || 'Failed to update purchase order';
      notify('error', errorMessage);
      return { success: false, error: errorMessage };
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error || error.message || 'Failed to update purchase order';
    handleApiError(error);
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
